/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-24 18:04:06
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-27 17:16:57
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\SupplierKOLTable\SupplierDesignatedKOLTable.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import {
  ProTablePlusForm,
  ProTablePlusFormRef,
} from '#components/ProTablePlusForm';
import type { AddGroupFormColumn } from '#components/ProTablePlusForm/addGroupTable';
import { ProCard, useScreenAdapterContext } from '@bedrock/eed-react';
import useDesignatedExpertColumns from '../cells/useDesignatedExpertColumns';
import { FullScreenButton } from '@mpc/components';
import { ReportedSwitch } from './ReportedSwitch';
import { Divider, Space, Tag } from '@bedrock/components';
import { useDebounceFn, useMemoizedFn } from 'ahooks';
import {
  createIsEqualWithIgnore,
  getDiff,
} from '@mpc/common/src/utils';

interface SupplierDesignatedKOLTableProps {
  /** 表格数据 */
  value?: any[];
  /** 数据变化回调 */
  onChange?: (value: any[]) => void;
  /** 是否是视图 */
  view?: boolean;
  /** 类名 */
  className?: string;
  /** 详情数据 */
  detailData?: any;
}


const isEqualWithIgnore = createIsEqualWithIgnore(['__table_row_key__', 'parent']);

/**
 * 指定达人表格组件
 */
export const SupplierDesignatedKOLTable = forwardRef<ProTablePlusFormRef, SupplierDesignatedKOLTableProps>(
  (props, ref) => {
    const {
      value = [],
      view = false,
      onChange,
      className,
      detailData,
    } = props;

    const { columnsConfig } = useDesignatedExpertColumns({
      view,
      // changeData: onChange,
      l3_category_id: detailData?.l3_category_id,
    });
    const [isFullscreen, setIsFullscreen] = useState(false);
    const { viewBase } = useScreenAdapterContext();
    const localValue = useRef(value);

    const getNewMergedValue = useMemoizedFn((newValue: any[]) => {
      const allKols = detailData?.demand_source_detail_vo?.demand_source_kol_vo || [];
      const newMergedValue = allKols.map((item: any, index: number) => {
        const key = item.id;
        const reportedItem = newValue.find((v: any) => v.demand_source_kol_id === key);
        
        if (reportedItem) {
          return {
            ...reportedItem,
            $isReported: true,
            index,
            id: item.id || item.demand_source_kol_id,
          };
        }
        
        return {
          ...item,
          demand_source_kol_id: item.id,
          $isReported: false,
          index,
          id: item.id || item.demand_source_kol_id,
        };
      });
      return newMergedValue;
    });

    const [mergedValue, setMergedValue] = useState<any[]>(getNewMergedValue(value));

    useEffect(() => {
      if (!isEqualWithIgnore(localValue.current, value)) {
        setMergedValue(getNewMergedValue(value));
      }
    }, [value]);

    const columns: AddGroupFormColumn[] = useMemo(() => {
      const list = [
        columnsConfig.index,
        columnsConfig.$isReported,
        columnsConfig.profile_of_the_expert,
        columnsConfig.cooperation_project,
        columnsConfig.exclusiveSign,
        columnsConfig.initialQuote,
        columnsConfig.count,
        columnsConfig.remarkDto,
        columnsConfig.cpm,
        columnsConfig.cpm_pv,
        columnsConfig.cpm_uv,
        columnsConfig.platform_quote_price,
        columnsConfig.platform_cpm,
        columnsConfig.platform_cpm_pv,
        columnsConfig.platform_cpm_uv,
      ].filter((n: any) => n && (n as any)?.show !== false) as AddGroupFormColumn[];

      return list.map(col => {
        if (col.dataIndex === '$isReported' || col.dataIndex === 'index') return col;

        const originalEditRender = col.editRender;
        if (!originalEditRender) return col;

        return {
          ...col,
          editRender: (params: any) => {
            const { row } = params;
            const isEditable = row?.$isReported === true;

            let config = typeof originalEditRender === 'function'
              ? originalEditRender(params)
              : originalEditRender;

            if (!isEditable) {
              config = {
                ...config,
                editable: false,
                props: {
                  ...config.props,
                },
                rule: {}
              };
            }
            return config;
          }
        };
      });
    }, [columnsConfig, detailData?.l3_category_id]);

    const localRef = useRef<ProTablePlusFormRef>(null);
    const wrapperRef = useRef(null);

    const {run: handleTableChange} = useDebounceFn((newData: any[]) => {
      const reportedData = newData.filter((item: any) => item.$isReported).map(n => {
        return {
          ...n,
          by_plan: true,
        };
      });
      if (isEqualWithIgnore(localValue.current, reportedData)) {
        return;
      }
      localValue.current = reportedData;
      onChange?.(reportedData);
      setMergedValue(getNewMergedValue(reportedData));
    });
    const [isReported, setIsReported] = useState(true);
    const onIsReportedChange = useMemoizedFn((checked: boolean) => {
      if(!checked && value.length > 0) {
        onChange?.([]);
      }
      setIsReported(checked);
    }, { wait: 100, leading: false, trailing: true });

    const [cardExpanded, setCardExpanded] = useState(true);
    useEffect(() => {
      setCardExpanded(isReported);
    }, [isReported]);


    const handleValidateFields = useMemoizedFn(() => {
      if (isReported && value.length === 0) {
        return Promise.reject('指定达人提报中，请至少提报1个达人');
      }
        return localRef.current?.validateFieldsAndScroll?.();
    });

    useImperativeHandle(ref, () => ({
      ...localRef.current,
      validateFields: () => {
        return localRef.current?.validateFieldsAndScroll?.();
      }
    }) as ProTablePlusFormRef, [localRef]);

    useEffect(() => {
      if(value.length > 0) {
        setIsReported(true);
      }
    }, [value]);


    return (
      <div ref={wrapperRef} className="mb-4">
        <ProCard
          title={<Space size={4}>
            <span>指定达人</span>
            <ReportedSwitch isReported={isReported} onIsReportedChange={onIsReportedChange} count={value.length} view={view} />
            </Space>}
          level={1}
          expandable={isReported}
          expanded={cardExpanded}
          onExpandedChange={setCardExpanded}
          rightSlot={
            <FullScreenButton
              fullRef={wrapperRef}
              handleFullChange={setIsFullscreen}
            />
          }
        >
          <ProTablePlusForm
            ref={localRef}
            columns={columns}
            value={mergedValue}
            className={className}
            rowKey="id"
            scroll={{ x: 'max-content', y: isFullscreen ? window.innerHeight - 140 * viewBase : 560 }}
            virtual={{ maxRows: 0, useAntd: false, itemHeight: 123 }}
            toolbar={{
              actionsInTitle: true,
            }}
            hoverColor={false}
            onChange={handleTableChange}
            verticalBorder
          />
        </ProCard>
      </div>
    );
  }
);

